import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import _ from 'lodash';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';

import { query } from 'actions/query';
import { QUERY_DATE_FMT } from '../../constants';

const fmtTimeParam = x => ((x instanceof moment) ? x.format(QUERY_DATE_FMT) : x);
const fmtTimeParamLive = x => ((x instanceof moment) ? x.format() : x);

const DEFAULT_RESPONSE = {
  resolved: true,
  failed: false,
  error: null,
  response: {
    content: {
      rows: [],
    },
  },
};

const provider = opts => (WrappedComponent) => {
  let options = {};
  let applied = false;

  class Model extends PureComponent {
    constructor(props) {
      super(props);
      const parameters = this.getParameters(props);
      const { dispatch, name } = this.props;

      if (parameters.get('zoneId')) {
        dispatch(query(name, parameters.get('endpoint'), parameters.get('zoneId'),
          parameters.get('startTime'),
          parameters.get('endTime'),
          parameters.get('dimensions').toJS(),
          parameters.get('metrics').toJS(),
          parameters.get('filters'),
          parameters.get('source') || ''));
      }

      this.state = {
        parameters,
      };
    }

    componentWillReceiveProps(nextProps) {
      const { parameters } = this.state;
      const newParameters = parameters.mergeDeep(this.getParameters(nextProps));
      if (newParameters !== parameters && !!newParameters.get('zoneId')) {
        const { dispatch, name } = nextProps;
        dispatch(query(name, newParameters.get('endpoint'), newParameters.get('zoneId'),
          newParameters.get('startTime'),
          newParameters.get('endTime'),
          newParameters.get('dimensions').toJS(),
          newParameters.get('metrics').toJS(),
          newParameters.get('filters'),
          newParameters.get('source') || ''));

        this.setState({ parameters: newParameters });
      }
    }

    getDownloadURL() {
      const { parameters } = this.state;
      const { name } = this.props;
      const action = query(name, parameters.get('endpoint') ? `${parameters.get('endpoint')}.csv` : 'query.csv', parameters.get('zoneId'),
        parameters.get('startTime'),
        parameters.get('endTime'),
        parameters.get('dimensions').toJS(),
        parameters.get('metrics').toJS(),
        parameters.get('filters'),
        parameters.get('source') || '');
      return action.payload.request.url;
    }

    getParameters(props) {
      const {
        startTime, endTime, dimensions, metrics, zoneId, endpoint, filters, source,
      } = props;
      const fmtTime = endpoint === 'live' ? fmtTimeParamLive : fmtTimeParam;
      return Immutable.Map(_.pickBy({
        startTime: fmtTime(startTime),
        endTime: fmtTime(endTime),
        dimensions: Immutable.List(_.isArray(dimensions) ? dimensions : [dimensions]),
        metrics: Immutable.List(_.isArray(metrics) ? metrics : [metrics]),
        zoneId,
        endpoint: endpoint || 'query',
        filters,
        source,
      }, p => !_.isUndefined(p))); // needed when removing existing lane filter
    }

    render() {
      const {
        prefix,
        data: {
          response, resolved, failed, error,
        },
        props,
      } = this.props;
      const { parameters } = this.state;
      const noZoneId = !parameters.get('zoneId');

      let propsToPass = noZoneId ? {
        fetching: false,
        result: { content: { rows: [] } },
        error: null,
        failed: null,
      } : {
        fetching: parameters === null ? true : !resolved,
        result: parameters === null ? null : response,
        error: parameters === null ? null : error,
        failed: parameters === null ? false : failed,
      };
      if (prefix) {
        propsToPass = {
          ..._(propsToPass)
            .chain()
            .toPairs()
            .map(x => [`${prefix || ''}${x[0]}`, x[1]])
            .fromPairs()
            .value(),
        };
      }
      return <WrappedComponent {...{ ...propsToPass, ...props }} />;
    }
  }
  Model.propTypes = {
    prefix: PropTypes.string,
    dispatch: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    props: PropTypes.any,
    startTime: PropTypes.oneOfType([PropTypes.string, momentPropTypes.momentObj]),
    endTime: PropTypes.oneOfType([PropTypes.string, momentPropTypes.momentObj]),
    data: PropTypes.shape({
      response: PropTypes.any,
      resolved: PropTypes.bool,
      failed: PropTypes.bool,
      error: PropTypes.any,
    }),
  };
  return connect((state, props) => {
    if (_.isFunction(opts) || !applied) {
      options = {
        ...options,
        ...(_.isFunction(opts) ? opts(props) : opts),
      };
      applied = true;
    }
    const hasZoneId = !!options.zoneId;
    if (!options.name && hasZoneId) {
      throw new Error('`name` was not defined in options to QueryProvider');
    }
    const data = (() => {
      if (hasZoneId) {
        return state.query[options.name] || { resolved: false };
      }
      return DEFAULT_RESPONSE;
    })();
    return {
      data,
      startTime: options.startTime,
      endTime: options.endTime,
      dimensions: options.dimensions,
      metrics: options.metrics,
      zoneId: options.zoneId,
      prefix: options.prefix,
      endpoint: options.endpoint,
      name: options.name,
      filters: options.filters,
      source: options.source,
      props,
    };
  }, null, null, { withRef: true })(Model);
};

export default provider;
